import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import injectSheet from 'react-jss';

import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { injectIntl } from 'react-intl';
import { testHasFlag } from '~/permissions/utils/testHasFlag';
import HtmlContent from '~/ui/components/HtmlContent/HtmlContent';

import EcCard from '../../Shared/EcCard/EcCard';
import EcProvisionsTable from '../../Shared/EcProvisionsTable/EcProvisionsTable';
import EcTable from '../../Shared/EcTable/EcTable';
import ClausesTable from './ClausesTable/ClausesTable';
import styles from './DocumentKeyProvisions.styles';
import MigratedProvisions from './MigratedProvisions/MigratedProvisions';

const keyProvisionsCardContentStyles = { display: 'flex', padding: '16px' };
const tableCardContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  padding: '16px',
};

class DocumentKeyProvisions extends Component {
  renderRebateTables() {
    const { rebateTables, handleTableUpdate, handleTableDelete } = this.props;

    if (!rebateTables || !rebateTables.length) return null;

    return (
      <Fragment>
        {rebateTables.map((table, index) => (
          <EcTable
            key={`documentPanelItem_${index}`}
            tableId={table.id}
            tableName={table.name}
            tableContent={table.html}
            handleTableUpdate={handleTableUpdate}
            handleTableDelete={handleTableDelete}
            allowRowChanges
            allowColumnChanges
            allowCellChanges
          />
        ))}
      </Fragment>
    );
  }

  renderPaymentTables() {
    const { classes, paymentTables, keyProvisions } = this.props;

    if (!paymentTables || !paymentTables.length) return null;

    return (
      <div className={classes.paymentTablesContent}>
        <EcCard
          title={this.props.intl.formatMessage({
            id: 'DocumentKeyProvisions.paymentTablesTitle',
            defaultMessage: 'Payment Tables',
            description: 'Title for payment tables section',
          })}
          contentStyles={tableCardContentStyles}
        >
          <HtmlContent className={classes.tablesItem} html={paymentTables} />
        </EcCard>
        {keyProvisions && keyProvisions.length ? (
          <div className={classes.horizontalSeparator} />
        ) : null}
      </div>
    );
  }

  renderMigratedProvisions = () => {
    const { documentId } = this.props;
    return <MigratedProvisions documentId={Number(documentId)} />;
  };

  renderKeyProvisions() {
    const { classes, keyProvisions, clauseIdToScroll } = this.props;

    const clausesTitle = this.props.intl.formatMessage({
      id: 'DocumentKeyProvisions.keyClausesTitle',
      defaultMessage: 'Key Clauses',
      description: 'Title for key clauses section',
    });
    if (!keyProvisions || !keyProvisions.length) {
      return (
        <EcCard title={clausesTitle}>
          <div className={classes.tableEmptyState}>
            <div className={classes.tableEmptyStateTitle}>
              {this.props.intl.formatMessage({
                id: 'DocumentKeyProvisions.noClausesTitle',
                defaultMessage: 'No key clauses found.',
                description: 'Title when no key clauses are found',
              })}
            </div>
            <div className={classes.tableEmptyStateMessage}>
              {this.props.intl.formatMessage({
                id: 'DocumentKeyProvisions.noClausesMessage',
                defaultMessage:
                  "Looks like we couldn't find any key clauses for this document.",
                description: 'Message when no key clauses are found',
              })}
            </div>
          </div>
        </EcCard>
      );
    }

    return (
      <EcCard
        title={clausesTitle}
        contentStyles={keyProvisionsCardContentStyles}
      >
        <EcProvisionsTable
          clauseIdToScroll={clauseIdToScroll}
          provisions={keyProvisions}
        />
      </EcCard>
    );
  }

  renderClausesTable = () => {
    const { documentId, clauseIdToScroll } = this.props;
    return (
      <ClausesTable
        handlerId={documentId}
        clauseIdToScroll={clauseIdToScroll}
      />
    );
  };

  render() {
    const { user } = this.props;
    const hasEditClauseFlag = testHasFlag(FeatureFlagType.EditClause)(user);
    return (
      <Fragment>
        {this.renderRebateTables()}
        {this.renderPaymentTables()}
        {hasEditClauseFlag ? (
          this.renderClausesTable()
        ) : (
          <>
            {this.renderMigratedProvisions()}
            {this.renderKeyProvisions()}
          </>
        )}
      </Fragment>
    );
  }
}

DocumentKeyProvisions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(injectIntl(DocumentKeyProvisions));
